import React from "react";

//* Layout
import SharedLayout from "../SharedLayout/SharedLayout.jsx";

//----------------------------------------------------------------

//* Getting this ready to merge the two layout files in to a
//* single unified file for maintainability.
//* 99% of the code in both is identical.
export default function ContactCenterLayout() {
	return <SharedLayout isContactCenter={true} />;
}
